import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import MuiCircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';

export const CircularProgress = (props) => {
  const {
    sx,
    variant = 'indeterminate',
    size = 30,
    thickness = 6.21,
    strokeDasharray = '20px, 200px',
    animationDuration = '750ms',
    lightModeColor = 'primary.light',
    darkModeColor = 'primary.light',
  } = props;

  return (
    <Box sx={{ position: 'relative', height: props.size, ...sx }}>
      <MuiCircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={size}
        thickness={thickness}
        {...props}
        value={100}
      />
      <MuiCircularProgress
        variant={variant}
        disableShrink
        sx={{
          color: (theme) => (theme.palette.mode === 'light' ? lightModeColor : darkModeColor),
          animationDuration: animationDuration,
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeDasharray: strokeDasharray,
          },
        }}
        size={size}
        thickness={thickness}
        {...props}
      />
    </Box>
  );
};

CircularProgress.propTypes = {
  sx: PropTypes.object,
  variant: PropTypes.string,
  size: PropTypes.number,
  thickness: PropTypes.number,
  strokeDasharray: PropTypes.string,
  animationDuration: PropTypes.string,
  lightModeColor: PropTypes.string,
  darkModeColor: PropTypes.string,
};
